var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b{fill:#e1e1e0}")),React.createElement("path",{"d":"M16.73 16H1.27A1.27 1.27 0 0 1 0 14.73v-8.2a1.28 1.28 0 0 1 .5-1L8.23.25a1.27 1.27 0 0 1 1.53 0l7.74 5.27a1.28 1.28 0 0 1 .5 1v8.2A1.27 1.27 0 0 1 16.73 16z","fill":"#d1d2d1","key":1}),React.createElement("path",{"className":"b","d":"M0 6.79v7.37l7.09-3.87L0 6.79zM10.91 10.28L18 14.16V6.79l-7.09 3.49z","key":2}),React.createElement("path",{"d":"M18 14.73v-.57L9 9.24l-9 4.92v.57A1.27 1.27 0 0 0 1.27 16h15.46A1.27 1.27 0 0 0 18 14.73z","fill":"#f0f0f0","key":3})]);
}

IconEmail.defaultProps = {"width":"18","height":"16"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
